"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const R = __importStar(require("ramda"));
const final_form_1 = require("final-form");
const react_final_form_1 = require("react-final-form");
const final_form_arrays_1 = __importDefault(require("final-form-arrays"));
const utils_1 = require("@8base/utils");
const error_codes_1 = __importDefault(require("@8base/error-codes"));
const table_schema_provider_1 = require("@8base-react/table-schema-provider");
const permissions_provider_1 = require("@8base-react/permissions-provider");
const FormContext_1 = require("./FormContext");
/**
 * `Form` wrapper based on `Form` from the [`react-final-form`](https://github.com/final-form/react-final-form). That accept [`FormProps`](https://github.com/final-form/react-final-form#formprops) props and some extra props for easy working with 8base API.
 * @prop {string} [tableSchemaName] - The name of the 8base API table schema.
 * @prop {string} [appName] - The name of the 8base API application.
 */
const Form = (_a) => {
    var { type, tableSchemaName, appName, formatRelationToIds, ignoreNonTableFields, beforeFormatDataForMutation, afterFormatDataForMutation, beforeFormatQueryData, afterFormatQueryData, onSuccess } = _a, props = __rest(_a, ["type", "tableSchemaName", "appName", "formatRelationToIds", "ignoreNonTableFields", "beforeFormatDataForMutation", "afterFormatDataForMutation", "beforeFormatQueryData", "afterFormatQueryData", "onSuccess"]);
    const { tablesList, loading } = react_1.useContext(table_schema_provider_1.TableSchemaContext);
    const { permissions } = react_1.useContext(permissions_provider_1.PermissionsContext);
    let tableSchema = null;
    if (tableSchemaName && tablesList) {
        tableSchema = utils_1.tablesListSelectors.getTableByName(tablesList, tableSchemaName, appName);
        if (beforeFormatQueryData) {
            props.initialValues = beforeFormatQueryData(props.initialValues);
        }
        if (tableSchema && type === utils_1.MUTATION_TYPE.UPDATE && props.initialValues) {
            props.initialValues = utils_1.formatDataAfterQuery(props.initialValues, {
                tableName: tableSchema.name,
                schema: tablesList,
            }, {
                formatRelationToIds,
            });
            if (afterFormatQueryData) {
                props.initialValues = afterFormatQueryData(props.initialValues);
            }
            props.initialValuesEqual = R.equals;
        }
        // Provide field schema to non basic fields
        if (!R.propIs(String, 'component', props)) {
            props = R.assoc('tableSchema', tableSchema, props);
        }
    }
    props = R.assoc('loading', loading, props);
    const skipData = (value, fieldSchema) => !permissions_provider_1.isAllowed({
        field: fieldSchema.name,
        permission: type && type.toLowerCase(),
        resource: tableSchema && tableSchema.name,
        type: 'data',
    }, permissions);
    // @ts-ignore
    props = R.evolve({
        onSubmit: onSubmit => (data, ...rest) => __awaiter(void 0, void 0, void 0, function* () {
            let result = null;
            let formattedData = data;
            if (beforeFormatDataForMutation) {
                formattedData = beforeFormatDataForMutation(data);
            }
            try {
                formattedData =
                    type && tableSchema && tablesList
                        ? utils_1.formatDataForMutation(type, formattedData, {
                            tableName: tableSchema.name,
                            schema: tablesList,
                            initialData: props.initialValues,
                        }, {
                            ignoreNonTableFields,
                            skip: permissions && skipData,
                        })
                        : formattedData;
                if (afterFormatDataForMutation) {
                    formattedData = afterFormatDataForMutation(formattedData);
                }
                // @ts-ignore
                result = yield onSubmit(formattedData, ...rest);
            }
            catch (e) {
                result = R.assoc('errors', e.graphQLErrors, result);
            }
            const errors = R.pathOr([], ['errors'], result);
            if (errors.length > 0) {
                const error = errors[0];
                if (error.code === error_codes_1.default.ValidationErrorCode) {
                    return error.details;
                }
                return { [final_form_1.FORM_ERROR]: error.message };
            }
            if (typeof onSuccess === 'function') {
                // @ts-ignore
                onSuccess(result, ...rest);
            }
            return result;
        }),
    }, props);
    props.mutators = R.merge(final_form_arrays_1.default, props.mutators);
    return (react_1.default.createElement(FormContext_1.FormContext.Provider, { value: { tableSchema, loading } },
        react_1.default.createElement(react_final_form_1.Form, Object.assign({}, props))));
};
exports.Form = Form;
Form.defaultProps = {
    ignoreNonTableFields: true,
    mutators: {},
};
//# sourceMappingURL=Form.js.map